import Navigation from 'components/Navigation';
import Slide from 'components/Slide';

const NotFound = () => {
  return (
    <div>
      <Slide title="404">
        <Navigation />
      </Slide>
    </div>
  );
};

export default NotFound;
